export default {
  "Section": "_Section_1h1jy_1",
  "SectionHeader": "_SectionHeader_1h1jy_7",
  "TwoCardGrid": "_TwoCardGrid_1h1jy_15",
  "ExtraPadding": "_ExtraPadding_1h1jy_24"
};import "ni:sha-256;-yflM9IiLC1tmjUaQ2Hl0CIXUJKZtESyVH-hGwxn1Ns";